'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _getFeatureFlags = require('ifeis-isomorphic/lib/redux/actions/feature-flags/getFeatureFlags');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PublicToolbarController = function () {
  function PublicToolbarController($mdSidenav, fSession, $state, config, $location, $ngRedux) {
    var _this = this;

    _classCallCheck(this, PublicToolbarController);

    this._ = { fSession: fSession };
    if ($location.search().logout === 'true') {
      this.user = undefined;
      $location.search('logout', null);
      this.logOut();
      return;
    }
    this.$state = $state;
    this.fSession = fSession;
    this.config = config;
    this.currentPath = $location.path();
    this._svc = {
      $mdSidenav: $mdSidenav, fSession: fSession
    };

    this.fSession.user().then(function (user) {
      _this.user = user;
    });

    var publicStates = ['home', 'organizers', 'dancers', 'teachers', 'results'];
    if (publicStates.some($state.includes)) {
      this.publicPage = true;
    }

    $ngRedux.dispatch((0, _getFeatureFlags.getFeatureFlags)()).then(function (response) {
      _this.isCrossNavigationEnabled = !!(response.payload && response.payload.flags.isCrossNavigationEnabled);
    });
  }

  _createClass(PublicToolbarController, [{
    key: 'toggleLeftNav',
    value: function toggleLeftNav() {
      this._svc.$mdSidenav('left').toggle();
    }
  }, {
    key: 'logOut',
    value: function logOut() {
      if (this.isCrossNavigationEnabled) {
        this._.fSession.logOut();
        var url = IFEIS_APPV2_URI + '/login';
        window.location.href = url;
      } else {
        this._.fSession.logOut();
      }
    }
  }, {
    key: 'navigateToLogin',
    value: function navigateToLogin() {
      if (this.isCrossNavigationEnabled) {
        var url = IFEIS_APPV2_URI + '/login';
        window.location.href = url;
      } else {
        this.$state.go('login');
      }
    }
  }, {
    key: 'navigateToExternalUrl',
    value: function navigateToExternalUrl() {
      window.location.replace(IFEIS_APPV2_URI + '/feiseanna-list');
    }
  }, {
    key: 'navigateToAccount',
    value: function navigateToAccount() {
      window.location.replace(IFEIS_APPV2_URI + '/account');
    }
  }]);

  return PublicToolbarController;
}();

exports.default = angular.module('ifeis.public-toolbar', ['ngMaterial']).directive('fPublicToolbar', function () {
  var fPublicToolbar = {
    restrict: 'AE',
    controller: 'PublicToolbarController',
    controllerAs: 'ctrl',
    template: require('./tpl.html'),
    replace: true,
    scope: {
      title: '@'
    },
    link: function link(scope, element, attrs) {}
  };

  return fPublicToolbar;
}).controller('PublicToolbarController', PublicToolbarController);


//////////////////
// WEBPACK FOOTER
// ./public-toolbar/index.js
// module id = 143
// module chunks = 0